<template>
  <div style="margin: 40px 0 0 0;">
    <el-card>

      <div slot="header">已绑定学生信息</div>
      <el-button style="float: right; padding: 3px 0; margin-right: 15px" type="text" size="mini"
        @click="bindUser">
        绑定用户
      </el-button>
      <el-table :data="bindStudents" border style="width: 100%;">
        <el-table-column prop="id" label="学生ID" width="100" />
        <el-table-column prop="userName" label="用户名" width="150" />
        <el-table-column prop="realName" label="姓名" width="150" />
        <el-table-column prop="school" label="学校" width="200" />
        <el-table-column prop="major" label="年级" width="120" />
        <el-table-column prop="gradeName" label="班级" width="150" />
        <el-table-column prop="phone" label="联系方式" width="150" />
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="openEditDialog(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-dialog
      title="绑定用户"
      :visible.sync="bindUserDialogVisible"
      width="50%"
      :close-on-click-modal="false"
      :before-close="handleBindDialogClose"
      :close-on-press-escape="false"
    >
      <div class="bind-user-dialog">
        <div class="search-section">
          <el-input
            v-model="searchUsername"
            placeholder="请输入用户名"
            class="search-input"
            :disabled="searchLoading"
            @keyup.enter.native="searchUser"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="searchUser"
              :loading="searchLoading"
            >搜索</el-button>
          </el-input>
        </div>

        <div v-if="searchError" class="search-error">
          {{ searchError }}
        </div>

        <div v-if="searchResult" class="search-result">
          <el-table
            :data="[searchResult]"
            border
            style="width: 100%"
            v-loading="searchLoading"
          >
            <el-table-column
              prop="userName"
              label="用户名"
              width="120"
            />
            <el-table-column
              prop="realName"
              label="真实姓名"
              width="120"
            />
            <el-table-column
              prop="school"
              label="学校"
              min-width="150"
            />
            <el-table-column
              prop="major"
              label="年级"
              width="120"
            />
            <el-table-column
              label="操作"
              width="120"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="mini"
                  @click="confirmBindUser(scope.row)"
                  :loading="bindLoading"
                  :disabled="bindLoading"
                >绑定</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div v-else-if="searchUsername && !searchLoading" class="no-result">
          <el-empty description="未找到相关用户" />
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title="编辑学生信息"
      :visible.sync="editDialogVisible"
      width="520px"
      :close-on-click-modal="false"
    >
      <el-form ref="editForm" :model="editForm" :rules="editRules" label-width="90px">
        <el-form-item label="用户名">
          <el-input v-model="editForm.userName" disabled />
        </el-form-item>
        <el-form-item label="真实姓名" prop="realName">
          <el-input v-model="editForm.realName" placeholder="请输入真实姓名" />
        </el-form-item>
        <el-form-item label="性别">
          <el-radio-group v-model="editForm.gender">
            <el-radio label="男">男</el-radio>
            <el-radio label="女">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="学校" prop="school">
          <el-input v-model="editForm.school" placeholder="请输入学校" />
        </el-form-item>
        <el-form-item label="年级" prop="major">
          <el-input v-model="editForm.major" placeholder="请输入年级" />
        </el-form-item>
        <el-form-item label="联系方式" prop="phone">
          <el-input v-model="editForm.phone" placeholder="请输入手机号" />
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="editForm.email" placeholder="请输入邮箱" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="editLoading" @click="saveStudentEdit">保存</el-button>
      </span>
    </el-dialog>
  </div>

</template>

<script>
import { searchUser, getParentBindStudents, parentBindStudent, updateUser } from '@/api/user'

export default {
  name: 'com-parent',
  data() {
    return {
      bindStudents: [],
      bindUserDialogVisible: false,
      searchUsername: '',
      searchLoading: false,
      searchError: '',
      searchResult: null,
      bindLoading: false,
      editDialogVisible: false,
      editLoading: false,
      editForm: {
        id: null,
        userName: '',
        realName: '',
        gender: '',
        school: '',
        major: '',
        phone: '',
        email: ''
      },
      editRules: {
        realName: [
          { max: 50, message: '真实姓名不能超过50个字符', trigger: 'blur' }
        ],
        school: [
          { max: 100, message: '学校名称不能超过100个字符', trigger: 'blur' }
        ],
        major: [
          { max: 50, message: '年级不能超过50个字符', trigger: 'blur' }
        ],
        phone: [
          { pattern: /^$|^1[3-9]\d{9}$/, message: '请输入正确的手机号格式', trigger: 'blur' }
        ],
        email: [
          { type: 'email', message: '请输入正确的邮箱格式', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    // 获取 parentId
    let parentId = null
    if (this.$store && this.$store.state.user && this.$store.state.user.data) {
      parentId = this.$store.state.user.data.id
    }
    if (!parentId) {
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo'))
        parentId = userInfo && (userInfo.id || (userInfo.data && userInfo.data.id))
      } catch (e) {}
    }
    if (parentId) {
      this.fetchBindStudents(parentId)
    } else {
      this.$message && this.$message.error('未获取到家长ID，请重新登录')
    }
  },
  methods: {
    async fetchBindStudents(parentId) {
      try {
        console.log('请求家长ID:', parentId)
        const res = await getParentBindStudents(parentId)
        console.log('家长绑定学生返回:', res)
        const studentList = res.data || []
        const detailPromises = studentList.map(item =>
          searchUser(item.studentName)
            .then(detailRes => {
              console.log('学生详细信息:', detailRes)
              return detailRes.data
            })
            .catch((err) => {
              console.error('查学生详细信息失败:', err)
              return null
            })
        )
        const details = await Promise.all(detailPromises)
        this.bindStudents = details.filter(Boolean)
      } catch (e) {
        console.error('获取绑定学生信息失败:', e)
        this.$message && this.$message.error('获取绑定学生信息失败')
      }
    },
    async getCurrentParentId() {
      let parentId = null
      if (this.$store && this.$store.state.user && this.$store.state.user.data && this.$store.state.user.data.id) {
        parentId = this.$store.state.user.data.id
      }
      if (!parentId) {
        try {
          const userInfo = JSON.parse(localStorage.getItem('userInfo'))
          parentId = userInfo && (userInfo.id || (userInfo.data && userInfo.data.id))
        } catch (e) {}
      }
      return parentId
    },
    bindUser() {
      this.bindUserDialogVisible = true
    },
    handleBindDialogClose(done) {
      this.searchUsername = ''
      this.searchError = ''
      this.searchResult = null
      done()
    },
    async searchUser() {
      if (!this.searchUsername) {
        this.searchError = '请输入用户名'
        return
      }
      this.searchLoading = true
      this.searchError = ''
      this.searchResult = null
      try {
        const res = await searchUser(this.searchUsername)
        if (res.code === 1 && res.data) {
          if (res.data.roleId !== 1) {
            this.searchError = '只能绑定学生用户'
            return
          }
          this.searchResult = res.data
        } else {
          this.searchError = '未找到相关用户'
        }
      } catch (e) {
        this.searchError = '搜索失败，请重试'
      } finally {
        this.searchLoading = false
      }
    },
    async confirmBindUser(user) {
      this.bindLoading = true
      try {
        const parentId = await this.getCurrentParentId()
        if (!parentId) {
          this.$message.error('未获取到家长账号ID，请重新登录')
          return
        }
        const res = await parentBindStudent({
          parentId,
          studentId: user.id
        })
        if (res.code === 1) {
          this.$message.success('绑定成功')
          this.bindUserDialogVisible = false
          this.searchUsername = ''
          this.searchResult = null
          this.fetchBindStudents(parentId)
        } else {
          this.$message.error(res.msg || '绑定失败')
        }
      } catch (e) {
        this.$message.error('绑定失败，请重试')
      } finally {
        this.bindLoading = false
      }
    },
    openEditDialog(student) {
      this.editForm = {
        id: student.id,
        userName: student.userName || '',
        realName: student.realName || '',
        gender: student.gender || '',
        school: student.school || '',
        major: student.major || '',
        phone: student.phone || '',
        email: student.email || ''
      }
      this.editDialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.editForm) {
          this.$refs.editForm.clearValidate()
        }
      })
    },
    async saveStudentEdit() {
      try {
        await this.$refs.editForm.validate()
      } catch (e) {
        return
      }
      this.editLoading = true
      try {
        const res = await updateUser({
          id: this.editForm.id,
          realName: this.editForm.realName,
          gender: this.editForm.gender,
          school: this.editForm.school,
          major: this.editForm.major,
          phone: this.editForm.phone,
          email: this.editForm.email
        })
        if (res.code === 1 || res.code === 200) {
          this.$message.success('学生信息更新成功')
          this.editDialogVisible = false
          const parentId = await this.getCurrentParentId()
          if (parentId) {
            this.fetchBindStudents(parentId)
          }
        } else {
          this.$message.error(res.msg || '更新失败')
        }
      } catch (e) {
        this.$message.error('更新失败，请重试')
      } finally {
        this.editLoading = false
      }
    }
  }
}
</script>
